export const deviceModel = {
   'name': {
      'title': "Name",
      'display': true
   },
   'location_id': {
      'title': "Location",
      'display': false
   },
   'location_id_name': {
      'title': "Location",
      'display': true
   },
   'collection_id': {
      'title': "Collection",
      'display': false
   },
   'collection_id_name': {
      'title': "Collection",
      'display': true
   },
   'number_of_ports': {
      'title': "Number of Ports",
      'display': false
   },
   'ip_address': {
      'title': "IP Address",
      'display': false
   }
};